import { render } from "./RedPadelRedirect.vue?vue&type=template&id=71ce9eba&ts=true"
import script from "./RedPadelRedirect.vue?vue&type=script&lang=ts"
export * from "./RedPadelRedirect.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__